import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { isDate, isValid } from 'date-fns';
import dayjs from 'dayjs';
import { FormError } from './hook-form-error';

export enum DateFormat {
  SIMPLE_DATE = 'MM/DD/YYYY',
}

interface DateLimits {
  maxDateEnabled?: boolean;
  maxDateValue?: string;
  minDateEnabled?: boolean;
  minDateValue?: string;
}
interface DateSelectFieldProps {
  label: string;
  name: string;
  onChange?: any;
  disabled?: boolean;
  format?: DateFormat;
  required?: boolean;
  dateLimits?: DateLimits;
}

const convertToDate = (value: any) => {
  if (value === null || value === undefined || value === "Invalid Date") {
    return null;
  }
  if (isDate(value)) {
    return value;
  }
  if (isValid(new Date(value))) {
    return dayjs(value);
  }
  return null;
};

export const formatSiTrackDate = (value: any, format?: DateFormat) => {
  if (value == null) return "";
  const date = dayjs(value);

  return format ? date.format(format) : date.toString();
};

export const FormDateField = ({
  name,
  label,
  required,
  format,
  disabled,
  onChange,
  dateLimits = {},
}: DateSelectFieldProps): any => {
  const { control, getValues } = useFormContext();
  const {
    maxDateEnabled = false,
    maxDateValue = dateLimits?.maxDateValue ?? '',
    minDateEnabled = false,
    minDateValue = dateLimits?.minDateValue ?? '',
  } = dateLimits;

  useWatch({
    name: [maxDateValue, minDateValue] || [],
  });

  const handleChange = (date: any) => { onChange(date); }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => {
          return (
            <>
              <DatePicker
                // onChange={(date: any) => onChange(formatSiTrackDate(convertToDate(date), format))}
                onChange={(date: any) => {
                  onChange(formatSiTrackDate(convertToDate(date), format))
                  handleChange(formatSiTrackDate(convertToDate(date), format));
                }}
                value={convertToDate(value)}
                slotProps={{ textField: { size: 'small', label: `${label}`, required } }}
                sx={{ width: '100%' }}
                maxDate={maxDateEnabled ? dayjs(getValues(maxDateValue)) : undefined}
                minDate={minDateEnabled ? dayjs(getValues(minDateValue)) : undefined}
                disabled={disabled}
              />
              <FormError name={name} />
            </>
          );
        }}
      />
    </LocalizationProvider>
  );
};

FormDateField.defaultProps = {
  label: undefined,
  onChange: () => {
    return;
  },
};

export default FormDateField;